import { CheckoutService } from '@/services';
import { Tracker } from '@/views/checkout/utilities/index';
import { ServiceResponse } from '@/core/services/interfaces';
import { Customer, Order } from '@/views/checkout/interfaces';
import { FORCE_REDIRECT_PAYMENT_METHODS } from '@/constants/payment-methods';
import { PAYMENT_METHOD_ID, PaymentMethod } from '@/core/payment-methods/constants';

export async function chargeMobilePay(order: Order, customer: Customer) {
    return CheckoutService.createMobilePaySession({
        orderCode: order.orderCode,
        customerEmail: customer.email,
        customerName: customer.fullName
    });
}

export function getForcedRedirectPaymentMethodId(
    paymentMethods: Array<PaymentMethod>
) {
    if (paymentMethods.length !== 1) {
        return null;
    }

    const paymentMethodId: PAYMENT_METHOD_ID = paymentMethods[0].id;

    if (!FORCE_REDIRECT_PAYMENT_METHODS.includes(paymentMethodId)) {
        return null;
    }

    return paymentMethodId;
}

export async function getPaymentMethodRedirectUrl(
    order: Order,
    customer: Customer,
    paymentMethodId: PAYMENT_METHOD_ID
) {
    try {
        let response: ServiceResponse<any>;

        switch (paymentMethodId) {
            case PAYMENT_METHOD_ID.MobilePay:
                response = await chargeMobilePay(order, customer);
                break;

            default:
                return null;
        }

        const {
            data,
            success,
            correlationId,
            eventId
        } = response;

        if (!success || !data.redirectUrl) {
            return null;
        }

        Tracker.trackPaymentResponse(
            success && (data?.success ?? true),
            paymentMethodId,
            correlationId,
            eventId,
            data?.redirectUrl
        );

        return data.redirectUrl;
    } catch (e) {
        return null;
    }
}
